import type { SVGProps } from 'react';

export const ReceiverIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="13" cy="7" r="6" fill="#E2E4E3" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3684 25C23.3684 19.3754 18.8088 14.8158 13.1842 14.8158C7.55962 14.8158 3 19.3754 3 25H23.3684Z"
      fill="#E2E4E3"
    />
    <path
      d="M17 24C17 27.866 20.134 31 24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17H17V24Z"
      fill="#8F8FFF"
    />
    <path
      d="M27.6 23.25H23.4V21L20.4 24L23.4 27V24.75H27.6V23.25Z"
      fill="white"
    />
  </svg>
);
